import { EconsultRequestTokenResponse, EconsultVerifyResponse } from "@shared/dtos/responses/econsultResponses.dto"
import { ValidationTokenChannel } from "@shared/enums/econsult"
import { Locale } from "@shared/enums/general"
import { PublicReplyEconsultRequest } from "@shared/zod/schemas/requests/econsult"
import { EconsultDetailPublicResponse } from "@shared/zod/schemas/responses/econsult"

import { axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"
import { makeFileInstance } from "./generic/FileInstance"

export const requestTokenPatient = async (
  id: string,
  locale: Locale,
  channel: ValidationTokenChannel
): Promise<EconsultRequestTokenResponse> => {
  const resp = await axiosPublic({
    url: `/public/econsults/${id}/token`,
    method: "get",
    params: {
      locale,
      channel,
    },
  })
  return resp.data
}

/**
 * Verifies the one-time code the patient entered and returns an access token used
 * (as the `token` param) on all subsequent public e-consult requests.
 */
export const verifyPatient = async (id: string, mfaToken: string): Promise<EconsultVerifyResponse> => {
  const resp = await axiosPublic({
    url: `/public/econsults/${id}/verify`,
    method: "post",
    data: { mfaToken },
  })
  return resp.data
}

export const getForPatient = async (id: string, token: string): Promise<EconsultDetailPublicResponse> => {
  const resp = await axiosPublic({
    url: `/public/econsults/${id}`,
    method: "get",
    params: {
      token,
    },
  })
  return resp.data
}

export const responseByPatient = async (id: string, token: string, req: PublicReplyEconsultRequest): Promise<void> => {
  await axiosPublic({
    url: `/public/econsults/${id}`,
    method: "post",
    params: {
      token,
    },
    data: req,
  })
  return undefined
}

export const downloadAttachment = async (
  econsultId: string,
  messageId: string,
  attachmentId: string,
  token: string
) => {
  const result = await axiosPublic({
    url: `/public/econsults/${econsultId}/${messageId}/attachment/${attachmentId}`,
    method: "get",
    responseType: "blob",
    params: {
      token,
    },
  })
  return makeFileInstance(result)
}
